export default __webpack_public_path__ + "static/media/banner-studio-mobile.04a6f013.png";